import { render } from "./UsersList.vue?vue&type=template&id=06fdd1b6&scoped=true&ts=true"
import script from "./UsersList.vue?vue&type=script&lang=ts"
export * from "./UsersList.vue?vue&type=script&lang=ts"

import "./UsersList.vue?vue&type=style&index=0&id=06fdd1b6&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06fdd1b6"]])

export default __exports__